import { render, staticRenderFns } from "./TaskKanbanItem.vue?vue&type=template&id=4fd67fee"
import script from "./TaskKanbanItem.vue?vue&type=script&lang=ts"
export * from "./TaskKanbanItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports